const countries = {
  "5be9d423104d06002ff0427e": {
    country_name: "Burkina Faso",
    country_name_ar: "بوركينا فاسو",
    region_code: "bf",
    country_code: "+226",
  },
  "5be9d423104d06002ff0426a": {
    country_name: "Aruba",
    country_name_ar: "أروبا",
    region_code: "aw",
    country_code: "+297",
  },
  "5be9d423104d06002ff04270": {
    country_name: "Andorra",
    country_name_ar: "أندورا",
    region_code: "ad",
    country_code: "+376",
  },
  "5be9d423104d06002ff04281": {
    country_name: "Bahrain",
    country_name_ar: "البحرين",
    region_code: "bh",
    country_code: "+973",
  },
  "5be9d423104d06002ff04291": {
    country_name: "Central African Republic",
    country_name_ar: "جمهوريّة أفريقيا الوسطى",
    region_code: "cf",
    country_code: "+236",
  },
  "5be9d423104d06002ff04292": {
    country_name: "Canada",
    country_name_ar: "كندا",
    region_code: "ca",
    country_code: "+1",
  },
  "5be9d423104d06002ff0427a": {
    country_name: "Azerbaijan",
    country_name_ar: "أذربيجان",
    region_code: "az",
    country_code: "+994",
  },
  "5be9d423104d06002ff04286": {
    country_name: "Belarus",
    country_name_ar: "بيلاروس",
    region_code: "by",
    country_code: "+375",
  },
  "5be9d423104d06002ff04290": {
    country_name: "Botswana",
    country_name_ar: "بوتسوانا",
    region_code: "bw",
    country_code: "+267",
  },
  "5be9d423104d06002ff04294": {
    country_name: "Switzerland",
    country_name_ar: "سويسرا",
    region_code: "ch",
    country_code: "+41",
  },
  "5be9d423104d06002ff04296": {
    country_name: "China",
    country_name_ar: "الصين",
    region_code: "cn",
    country_code: "+86",
  },
  "5be9d423104d06002ff042a6": {
    country_name: "Germany",
    country_name_ar: "ألمانيا",
    region_code: "de",
    country_code: "+49",
  },
  "5be9d423104d06002ff04283": {
    country_name: "Bosnia and Herzegovina",
    country_name_ar: "البوسنة والهرسك",
    region_code: "ba",
    country_code: "+387",
  },
  "5be9d423104d06002ff04282": {
    country_name: "Bahamas",
    country_name_ar: "جزر البهاما",
    region_code: "bs",
    country_code: "+1-242",
  },
  "5be9d423104d06002ff0426f": {
    country_name: "Albania",
    country_name_ar: "ألبانيا",
    region_code: "al",
    country_code: "+355",
  },
  "5be9d423104d06002ff042a2": {
    country_name: "Christmas Island",
    country_name_ar: "جزيرة الكريسماس",
    region_code: "cx",
    country_code: "+61",
  },
  "5be9d423104d06002ff04273": {
    country_name: "Armenia",
    country_name_ar: "أرمينيا",
    region_code: "am",
    country_code: "+374",
  },
  "5be9d423104d06002ff04279": {
    country_name: "Austria",
    country_name_ar: "النمسا",
    region_code: "at",
    country_code: "+43",
  },
  "5be9d423104d06002ff0427f": {
    country_name: "Bangladesh",
    country_name_ar: "بنغلاديش",
    region_code: "bd",
    country_code: "+880",
  },
  "5be9d423104d06002ff0427b": {
    country_name: "Burundi",
    country_name_ar: "بوروندي",
    region_code: "bi",
    country_code: "+257",
  },
  "5be9d423104d06002ff04298": {
    country_name: "Cameroon",
    country_name_ar: "الكاميرون",
    region_code: "cm",
    country_code: "+237",
  },
  "5be9d423104d06002ff0429d": {
    country_name: "Comoros",
    country_name_ar: "جزر القمر",
    region_code: "km",
    country_code: "+269",
  },
  "5be9d423104d06002ff0429f": {
    country_name: "Costa Rica",
    country_name_ar: "كوستاريكا",
    region_code: "cr",
    country_code: "+506",
  },
  "5be9d423104d06002ff0426b": {
    country_name: "Afghanistan",
    country_name_ar: "أفغانستان",
    region_code: "af",
    country_code: "+93",
  },
  "5be9d423104d06002ff04271": {
    country_name: "United Arab Emirates",
    country_name_ar: "الإمارات العربيّة المتحدة",
    region_code: "ae",
    country_code: "+971",
  },
  "5be9d423104d06002ff04274": {
    country_name: "American Samoa",
    country_name_ar: "ساموا الأمريكية",
    region_code: "as",
    country_code: "+1-684",
  },
  "5be9d423104d06002ff0427c": {
    country_name: "Belgium",
    country_name_ar: "بلجيكا",
    region_code: "be",
    country_code: "+32",
  },
  "5be9d423104d06002ff0429a": {
    country_name: "Republic of the Congo",
    country_name_ar: "الكونغو",
    region_code: "cg",
    country_code: "+242",
  },
  "5be9d423104d06002ff0426d": {
    country_name: "Anguilla",
    country_name_ar: "أنغيلا",
    region_code: "ai",
    country_code: "+1-264",
  },
  "5be9d423104d06002ff0427d": {
    country_name: "Benin",
    country_name_ar: "بنن",
    region_code: "bj",
    country_code: "+229",
  },
  "5be9d423104d06002ff0429b": {
    country_name: "Cook Islands",
    country_name_ar: "جزر كوك",
    region_code: "ck",
    country_code: "+682",
  },
  "5be9d423104d06002ff0429c": {
    country_name: "Colombia",
    country_name_ar: "كولومبيا",
    region_code: "co",
    country_code: "+57",
  },
  "5be9d423104d06002ff04295": {
    country_name: "Chile",
    country_name_ar: "شيلي",
    region_code: "cl",
    country_code: "+56",
  },
  "5be9d423104d06002ff04272": {
    country_name: "Argentina",
    country_name_ar: "الأرجنتين",
    region_code: "ar",
    country_code: "+54",
  },
  "5be9d423104d06002ff04297": {
    country_name: "Ivory Coast",
    country_name_ar: "كوت ديفوار",
    region_code: "ci",
    country_code: "+225",
  },
  "5be9d423104d06002ff0429e": {
    country_name: "Cape Verde",
    country_name_ar: "كابو فيردي",
    region_code: "cv",
    country_code: "+238",
  },
  "5be9d423104d06002ff04287": {
    country_name: "Belize",
    country_name_ar: "بليز",
    region_code: "bz",
    country_code: "+501",
  },
  "5be9d423104d06002ff04280": {
    country_name: "Bulgaria",
    country_name_ar: "بلغاريا",
    region_code: "bg",
    country_code: "+359",
  },
  "5be9d423104d06002ff0426c": {
    country_name: "Angola",
    country_name_ar: "أنغولا",
    region_code: "ao",
    country_code: "+244",
  },
  "5be9d423104d06002ff04288": {
    country_name: "Bermuda",
    country_name_ar: "برمودا",
    region_code: "bm",
    country_code: "+1-441",
  },
  "5be9d423104d06002ff0428c": {
    country_name: "Barbados",
    country_name_ar: "بربادوس",
    region_code: "bb",
    country_code: "+1-246",
  },
  "5be9d423104d06002ff04277": {
    country_name: "Antigua and Barbuda",
    country_name_ar: "أنتيغوا وبربودا",
    region_code: "ag",
    country_code: "+1-268",
  },
  "5be9d423104d06002ff04278": {
    country_name: "Australia",
    country_name_ar: "أستراليا",
    region_code: "au",
    country_code: "+61",
  },
  "5be9d423104d06002ff042a3": {
    country_name: "Cayman Islands",
    country_name_ar: "جزر كايمان",
    region_code: "ky",
    country_code: "+1-345",
  },
  "5be9d423104d06002ff042a7": {
    country_name: "Djibouti",
    country_name_ar: "جيبوتي",
    region_code: "dj",
    country_code: "+253",
  },
  "5be9d423104d06002ff042a9": {
    country_name: "Denmark",
    country_name_ar: "الدنمارك",
    region_code: "dk",
    country_code: "+45",
  },
  "5be9d423104d06002ff04289": {
    country_name: "Bolivia",
    country_name_ar: "بوليفيا",
    region_code: "bo",
    country_code: "+591",
  },
  "5be9d423104d06002ff0428b": {
    country_name: "Brazil",
    country_name_ar: "البرازيل",
    region_code: "br",
    country_code: "+55",
  },
  "5be9d423104d06002ff0428d": {
    country_name: "Brunei",
    country_name_ar: "بروني دار السلام",
    region_code: "bn",
    country_code: "+673",
  },
  "5be9d423104d06002ff0428e": {
    country_name: "Bhutan",
    country_name_ar: "بوتان",
    region_code: "bt",
    country_code: "+975",
  },
  "5be9d423104d06002ff042a0": {
    country_name: "Cuba",
    country_name_ar: "كوبا",
    region_code: "cu",
    country_code: "+53",
  },
  "5be9d423104d06002ff042a4": {
    country_name: "Cyprus",
    country_name_ar: "قبرص",
    region_code: "cy",
    country_code: "+357",
  },
  "5be9d423104d06002ff042a8": {
    country_name: "Dominica",
    country_name_ar: "دومينيكا",
    region_code: "dm",
    country_code: "+1-767",
  },
  "5be9d423104d06002ff042b9": {
    country_name: "Gabon",
    country_name_ar: "غابون",
    region_code: "ga",
    country_code: "+241",
  },
  "5be9d423104d06002ff042ba": {
    country_name: "United Kingdom",
    country_name_ar: "المملكة المتحدة",
    region_code: "gb",
    country_code: "+44",
  },
  "5be9d423104d06002ff042cd": {
    country_name: "Honduras",
    country_name_ar: "هندوراس",
    region_code: "hn",
    country_code: "+504",
  },
  "5be9d423104d06002ff042ef": {
    country_name: "Lesotho",
    country_name_ar: "ليسوتو",
    region_code: "ls",
    country_code: "+266",
  },
  "5be9d423104d06002ff042f2": {
    country_name: "Latvia",
    country_name_ar: "لاتفيا",
    region_code: "lv",
    country_code: "+371",
  },
  "5be9d423104d06002ff04311": {
    country_name: "Niue",
    country_name_ar: "نيوي",
    region_code: "nu",
    country_code: "+683",
  },
  "5be9d423104d06002ff04312": {
    country_name: "Netherlands",
    country_name_ar: "هولندا",
    region_code: "nl",
    country_code: "+31",
  },
  "5be9d423104d06002ff0432e": {
    country_name: "Singapore",
    country_name_ar: "سنغافورة",
    region_code: "sg",
    country_code: "+65",
  },
  "5be9d423104d06002ff0435a": {
    country_name: "British Virgin Islands",
    country_name_ar: "جزر فيرجن البريطانية",
    region_code: "vg",
    country_code: "+1-284",
  },
  "5be9d423104d06002ff042b1": {
    country_name: "Estonia",
    country_name_ar: "إستونيا",
    region_code: "ee",
    country_code: "+372",
  },
  "5be9d423104d06002ff042c3": {
    country_name: "Equatorial Guinea",
    country_name_ar: "غينيا الاستوائيّة",
    region_code: "gq",
    country_code: "+240",
  },
  "5be9d423104d06002ff042c5": {
    country_name: "Grenada",
    country_name_ar: "غرينادا",
    region_code: "gd",
    country_code: "+1-473",
  },
  "5be9d423104d06002ff042c6": {
    country_name: "Greenland",
    country_name_ar: "الأرض الخضراء",
    region_code: "gl",
    country_code: "+299",
  },
  "5be9d423104d06002ff042d1": {
    country_name: "Indonesia",
    country_name_ar: "إندونيسيا",
    region_code: "id",
    country_code: "+62",
  },
  "5be9d423104d06002ff042f0": {
    country_name: "Lithuania",
    country_name_ar: "ليتوانيا",
    region_code: "lt",
    country_code: "+370",
  },
  "5be9d423104d06002ff0430f": {
    country_name: "Nigeria",
    country_name_ar: "نيجيريا",
    region_code: "ng",
    country_code: "+234",
  },
  "5be9d423104d06002ff04319": {
    country_name: "Panama",
    country_name_ar: "بنما",
    region_code: "pa",
    country_code: "+507",
  },
  "5be9d423104d06002ff04326": {
    country_name: "Qatar",
    country_name_ar: "قطر",
    region_code: "qa",
    country_code: "+974",
  },
  "5be9d423104d06002ff0432a": {
    country_name: "Rwanda",
    country_name_ar: "رواندا",
    region_code: "rw",
    country_code: "+250",
  },
  "5be9d423104d06002ff04335": {
    country_name: "Somalia",
    country_name_ar: "الصومال",
    region_code: "so",
    country_code: "+252",
  },
  "5be9d423104d06002ff0433b": {
    country_name: "Slovakia",
    country_name_ar: "سلوفاكيا",
    region_code: "sk",
    country_code: "+421",
  },
  "5be9d423104d06002ff042e1": {
    country_name: "Kyrgyzstan",
    country_name_ar: "قيرغيزستان",
    region_code: "kg",
    country_code: "+996",
  },
  "5be9d423104d06002ff042e3": {
    country_name: "Kiribati",
    country_name_ar: "كيريباس",
    region_code: "ki",
    country_code: "+686",
  },
  "5be9d423104d06002ff042e5": {
    country_name: "South Korea",
    country_name_ar: "جمهوريّة كوريا",
    region_code: "kr",
    country_code: "+82",
  },
  "5be9d423104d06002ff042ed": {
    country_name: "Liechtenstein",
    country_name_ar: "ليختنشتاين",
    region_code: "li",
    country_code: "+423",
  },
  "5be9d423104d06002ff04300": {
    country_name: "Montenegro",
    country_name_ar: "الجبل الأسود",
    region_code: "me",
    country_code: "+382",
  },
  "5be9d423104d06002ff04310": {
    country_name: "Nicaragua",
    country_name_ar: "نيكاراغوا",
    region_code: "ni",
    country_code: "+505",
  },
  "5be9d423104d06002ff04313": {
    country_name: "Norway",
    country_name_ar: "النرويج",
    region_code: "no",
    country_code: "+47",
  },
  "5be9d423104d06002ff0433d": {
    country_name: "Sweden",
    country_name_ar: "السويد",
    region_code: "se",
    country_code: "+46",
  },
  "5be9d423104d06002ff0435c": {
    country_name: "Vietnam",
    country_name_ar: "فييت نام",
    region_code: "vn",
    country_code: "+84",
  },
  "5be9d423104d06002ff0435f": {
    country_name: "Samoa",
    country_name_ar: "ساموا",
    region_code: "ws",
    country_code: "+685",
  },
  "5be9d423104d06002ff04361": {
    country_name: "South Africa",
    country_name_ar: "جنوب أفريقيا",
    region_code: "za",
    country_code: "+27",
  },
  "5be9d423104d06002ff042b7": {
    country_name: "Faroe Islands",
    country_name_ar: "جزر فيرويه",
    region_code: "fo",
    country_code: "+298",
  },
  "5be9d423104d06002ff042bb": {
    country_name: "Georgia",
    country_name_ar: "جورجيا",
    region_code: "ge",
    country_code: "+995",
  },
  "5be9d423104d06002ff042cb": {
    country_name: "Hong Kong",
    country_name_ar: "هونغ كونغ",
    region_code: "hk",
    country_code: "+852",
  },
  "5be9d423104d06002ff042d6": {
    country_name: "Iran",
    country_name_ar: "إيران",
    region_code: "ir",
    country_code: "+98",
  },
  "5be9d423104d06002ff042d7": {
    country_name: "Iraq",
    country_name_ar: "العراق",
    region_code: "iq",
    country_code: "+964",
  },
  "5be9d423104d06002ff042fa": {
    country_name: "Mexico",
    country_name_ar: "المكسيك",
    region_code: "mx",
    country_code: "+52",
  },
  "5be9d423104d06002ff04316": {
    country_name: "New Zealand",
    country_name_ar: "نيوزيلندا",
    region_code: "nz",
    country_code: "+64",
  },
  "5be9d423104d06002ff04330": {
    country_name: "Svalbard and Jan Mayen",
    country_name_ar: "سفالبارد وجان مايان",
    region_code: "sj",
    country_code: "+47",
  },
  "5be9d423104d06002ff04337": {
    country_name: "Serbia",
    country_name_ar: "صربيا",
    region_code: "rs",
    country_code: "+381",
  },
  "5be9d423104d06002ff04358": {
    country_name: "Saint Vincent and the Grenadines",
    country_name_ar: "سانت فنسنت وجزر غرينادين",
    region_code: "vc",
    country_code: "+1-784",
  },
  "5be9d423104d06002ff042ad": {
    country_name: "Egypt",
    country_name_ar: "مصر",
    region_code: "eg",
    country_code: "+20",
  },
  "5be9d423104d06002ff042ea": {
    country_name: "Liberia",
    country_name_ar: "ليبريا",
    region_code: "lr",
    country_code: "+231",
  },
  "5be9d423104d06002ff042f6": {
    country_name: "Monaco",
    country_name_ar: "موناكو",
    region_code: "mc",
    country_code: "+377",
  },
  "5be9d423104d06002ff042f9": {
    country_name: "Maldives",
    country_name_ar: "ملديف",
    region_code: "mv",
    country_code: "+960",
  },
  "5be9d423104d06002ff0433a": {
    country_name: "Suriname",
    country_name_ar: "سورينام",
    region_code: "sr",
    country_code: "+597",
  },
  "5be9d423104d06002ff04359": {
    country_name: "Venezuela",
    country_name_ar: "فنزويلا",
    region_code: "ve",
    country_code: "+58",
  },
  "5be9d423104d06002ff04363": {
    country_name: "Zimbabwe",
    country_name_ar: "زمبابوي",
    region_code: "zw",
    country_code: "+263",
  },
  "5be9d423104d06002ff042d2": {
    country_name: "Isle of Man",
    country_name_ar: "جزيرة آيل أوف مان",
    region_code: "im",
    country_code: "+44-1624",
  },
  "5be9d423104d06002ff042d5": {
    country_name: "Ireland",
    country_name_ar: "آيرلندا",
    region_code: "ie",
    country_code: "+353",
  },
  "5be9d423104d06002ff042dc": {
    country_name: "Jersey",
    country_name_ar: "جيرسي",
    region_code: "je",
    country_code: "+44-1534",
  },
  "5be9d423104d06002ff042f4": {
    country_name: "Saint Martin",
    country_name_ar: "القديس مارتن",
    region_code: "gp",
    country_code: "+590",
  },
  "5be9d423104d06002ff04308": {
    country_name: "Malawi",
    country_name_ar: "ملاوي",
    region_code: "mw",
    country_code: "+265",
  },
  "5be9d423104d06002ff0430b": {
    country_name: "Namibia",
    country_name_ar: "ناميبيا",
    region_code: "na",
    country_code: "+264",
  },
  "5be9d423104d06002ff0431c": {
    country_name: "Philippines",
    country_name_ar: "الفلبين",
    region_code: "ph",
    country_code: "+63",
  },
  "5be9d423104d06002ff04336": {
    country_name: "Saint Pierre and Miquelon",
    country_name_ar: "سان بيار وميكلون",
    region_code: "pm",
    country_code: "+508",
  },
  "5be9d423104d06002ff042ab": {
    country_name: "Algeria",
    country_name_ar: "الجزائر",
    region_code: "dz",
    country_code: "+213",
  },
  "5be9d423104d06002ff042b3": {
    country_name: "Finland",
    country_name_ar: "فنلندا",
    region_code: "fi",
    country_code: "+358",
  },
  "5be9d423104d06002ff04314": {
    country_name: "Nepal",
    country_name_ar: "نيبال",
    region_code: "np",
    country_code: "+977",
  },
  "5be9d423104d06002ff04332": {
    country_name: "Sierra Leone",
    country_name_ar: "سيراليون",
    region_code: "sl",
    country_code: "+232",
  },
  "5be9d423104d06002ff0433f": {
    country_name: "Sint Maarten",
    country_name_ar: "سينت مارتن",
    region_code: "sx",
    country_code: "+1-721",
  },
  "5be9d423104d06002ff0434c": {
    country_name: "Tunisia",
    country_name_ar: "تونس",
    region_code: "tn",
    country_code: "+216",
  },
  "5be9d423104d06002ff0435e": {
    country_name: "Wallis and Futuna",
    country_name_ar: "واليس وفوتونا",
    region_code: "wf",
    country_code: "+681",
  },
  "5be9d423104d06002ff04362": {
    country_name: "Zambia",
    country_name_ar: "زامبيا",
    region_code: "zm",
    country_code: "+260",
  },
  "5be9d423104d06002ff042ae": {
    country_name: "Eritrea",
    country_name_ar: "إريتريا",
    region_code: "er",
    country_code: "+291",
  },
  "5be9d423104d06002ff042b6": {
    country_name: "France",
    country_name_ar: "فرنسا",
    region_code: "fr",
    country_code: "+33",
  },
  "5be9d423104d06002ff042df": {
    country_name: "Kazakhstan",
    country_name_ar: "كازاخستان",
    region_code: "kz",
    country_code: "+7",
  },
  "5be9d423104d06002ff042e0": {
    country_name: "Kenya",
    country_name_ar: "كينيا",
    region_code: "ke",
    country_code: "+254",
  },
  "5be9d423104d06002ff042ee": {
    country_name: "Sri Lanka",
    country_name_ar: "سري لانكا",
    region_code: "lk",
    country_code: "+94",
  },
  "5be9d423104d06002ff042f5": {
    country_name: "Morocco",
    country_name_ar: "المغرب",
    region_code: "ma",
    country_code: "+212",
  },
  "5be9d423104d06002ff042ff": {
    country_name: "Myanmar",
    country_name_ar: "ميانمار",
    region_code: "mm",
    country_code: "+95",
  },
  "5be9d423104d06002ff04301": {
    country_name: "Mongolia",
    country_name_ar: "منغوليا",
    region_code: "mn",
    country_code: "+976",
  },
  "5be9d423104d06002ff04303": {
    country_name: "Mozambique",
    country_name_ar: "موزامبيق",
    region_code: "mz",
    country_code: "+258",
  },
  "5be9d423104d06002ff0431b": {
    country_name: "Peru",
    country_name_ar: "بيرو",
    region_code: "pe",
    country_code: "+51",
  },
  "5be9d423104d06002ff04331": {
    country_name: "Solomon Islands",
    country_name_ar: "جزر سليمان",
    region_code: "sb",
    country_code: "+677",
  },
  "5be9d423104d06002ff04338": {
    country_name: "South Sudan",
    country_name_ar: "جنوب السودان",
    region_code: "ss",
    country_code: "+211",
  },
  "5be9d423104d06002ff04342": {
    country_name: "Turks and Caicos Islands",
    country_name_ar: "جزر تركس وكايكوس",
    region_code: "tc",
    country_code: "+1-649",
  },
  "5be9d423104d06002ff04347": {
    country_name: "Tokelau",
    country_name_ar: "توكيلاو",
    region_code: "tk",
    country_code: "+690",
  },
  "5be9d423104d06002ff0434a": {
    country_name: "Tonga",
    country_name_ar: "تونغا",
    region_code: "to",
    country_code: "+676",
  },
  "5be9d423104d06002ff042ce": {
    country_name: "Croatia",
    country_name_ar: "كرواتيا",
    region_code: "hr",
    country_code: "+385",
  },
  "5be9d423104d06002ff042d4": {
    country_name: "British Indian Ocean Territory",
    country_name_ar: "إقليم المحيط البريطاني الهندي",
    region_code: "io",
    country_code: "+246",
  },
  "5be9d423104d06002ff042f7": {
    country_name: "Moldova",
    country_name_ar: "جمهوريّة مولدوفا",
    region_code: "md",
    country_code: "+373",
  },
  "5be9d423104d06002ff04318": {
    country_name: "Pakistan",
    country_name_ar: "باكستان",
    region_code: "pk",
    country_code: "+92",
  },
  "5be9d423104d06002ff04325": {
    country_name: "French Polynesia",
    country_name_ar: "بولينيزيا الفرنسية",
    region_code: "pf",
    country_code: "+689",
  },
  "5be9d423104d06002ff04346": {
    country_name: "Tajikistan",
    country_name_ar: "طاجيكستان",
    region_code: "tj",
    country_code: "+992",
  },
  "5be9d423104d06002ff0434f": {
    country_name: "Taiwan",
    country_name_ar: "تايوان",
    region_code: "tw",
    country_code: "+886",
  },
  "5be9d423104d06002ff04352": {
    country_name: "Ukraine",
    country_name_ar: "أوكرانيا",
    region_code: "ua",
    country_code: "+380",
  },
  "5be9d423104d06002ff042bd": {
    country_name: "Ghana",
    country_name_ar: "غانا",
    region_code: "gh",
    country_code: "+233",
  },
  "5be9d423104d06002ff042be": {
    country_name: "Gibraltar",
    country_name_ar: "جبل طارق",
    region_code: "gi",
    country_code: "+350",
  },
  "5be9d423104d06002ff042c4": {
    country_name: "Greece",
    country_name_ar: "اليونان",
    region_code: "gr",
    country_code: "+30",
  },
  "5be9d423104d06002ff042ca": {
    country_name: "Guyana",
    country_name_ar: "غيانا",
    region_code: "gy",
    country_code: "+592",
  },
  "5be9d423104d06002ff042db": {
    country_name: "Jamaica",
    country_name_ar: "جامايكا",
    region_code: "jm",
    country_code: "+1-876",
  },
  "5be9d423104d06002ff042dd": {
    country_name: "Jordan",
    country_name_ar: "الأردن",
    region_code: "jo",
    country_code: "+962",
  },
  "5be9d423104d06002ff042de": {
    country_name: "Japan",
    country_name_ar: "اليابان",
    region_code: "jp",
    country_code: "+81",
  },
  "5be9d423104d06002ff042f3": {
    country_name: "Macau",
    country_name_ar: "ماكاو",
    region_code: "mo",
    country_code: "+853",
  },
  "5be9d423104d06002ff042fe": {
    country_name: "Malta",
    country_name_ar: "مالطة",
    region_code: "mt",
    country_code: "+356",
  },
  "5be9d423104d06002ff0430d": {
    country_name: "Niger",
    country_name_ar: "النيجر",
    region_code: "ne",
    country_code: "+227",
  },
  "5be9d423104d06002ff04317": {
    country_name: "Oman",
    country_name_ar: "عمان",
    region_code: "om",
    country_code: "+968",
  },
  "5be9d423104d06002ff0431d": {
    country_name: "Palau",
    country_name_ar: "بالاو",
    region_code: "pw",
    country_code: "+680",
  },
  "5be9d423104d06002ff04328": {
    country_name: "Romania",
    country_name_ar: "رومانيا",
    region_code: "ro",
    country_code: "+40",
  },
  "5be9d423104d06002ff04333": {
    country_name: "El Salvador",
    country_name_ar: "السلفادور",
    region_code: "sv",
    country_code: "+503",
  },
  "5be9d423104d06002ff0433c": {
    country_name: "Slovenia",
    country_name_ar: "سلوفينيا",
    region_code: "si",
    country_code: "+386",
  },
  "5be9d423104d06002ff042ac": {
    country_name: "Ecuador",
    country_name_ar: "إكوادور",
    region_code: "ec",
    country_code: "+593",
  },
  "5be9d423104d06002ff042bf": {
    country_name: "Guinea",
    country_name_ar: "غينيا",
    region_code: "gn",
    country_code: "+224",
  },
  "5be9d423104d06002ff042c1": {
    country_name: "Gambia",
    country_name_ar: "غامبيا",
    region_code: "gm",
    country_code: "+220",
  },
  "5be9d423104d06002ff042da": {
    country_name: "Italy",
    country_name_ar: "إيطاليا",
    region_code: "it",
    country_code: "+39",
  },
  "5be9d423104d06002ff042e7": {
    country_name: "Kuwait",
    country_name_ar: "الكويت",
    region_code: "kw",
    country_code: "+965",
  },
  "5be9d423104d06002ff042f1": {
    country_name: "Luxembourg",
    country_name_ar: "لكسمبرغ",
    region_code: "lu",
    country_code: "+352",
  },
  "5be9d423104d06002ff04304": {
    country_name: "Mauritania",
    country_name_ar: "موريتانيا",
    region_code: "mr",
    country_code: "+222",
  },
  "5be9d423104d06002ff04307": {
    country_name: "Mauritius",
    country_name_ar: "موريشيوس",
    region_code: "mu",
    country_code: "+230",
  },
  "5be9d423104d06002ff04309": {
    country_name: "Malaysia",
    country_name_ar: "ماليزيا",
    region_code: "my",
    country_code: "+60",
  },
  "5be9d423104d06002ff0434b": {
    country_name: "Trinidad and Tobago",
    country_name_ar: "ترينيداد وتوباغو",
    region_code: "tt",
    country_code: "+1-868",
  },
  "5be9d423104d06002ff0434d": {
    country_name: "Turkey",
    country_name_ar: "تركيا",
    region_code: "tr",
    country_code: "+90",
  },
  "5be9d423104d06002ff042d3": {
    country_name: "India",
    country_name_ar: "الهند",
    region_code: "in",
    country_code: "+91",
  },
  "5be9d423104d06002ff04302": {
    country_name: "Northern Mariana Islands",
    country_name_ar: "جزر مريانا الشمالية",
    region_code: "mp",
    country_code: "+1-670",
  },
  "5be9d423104d06002ff04305": {
    country_name: "Montserrat",
    country_name_ar: "مونتسيرات",
    region_code: "ms",
    country_code: "+1-664",
  },
  "5be9d423104d06002ff04329": {
    country_name: "Russia",
    country_name_ar: "الاتحاد الروسي",
    region_code: "ru",
    country_code: "+7",
  },
  "5be9d423104d06002ff0432d": {
    country_name: "Senegal",
    country_name_ar: "السنغال",
    region_code: "sn",
    country_code: "+221",
  },
  "5be9d423104d06002ff04334": {
    country_name: "San Marino",
    country_name_ar: "سان مارينو",
    region_code: "sm",
    country_code: "+378",
  },
  "5be9d423104d06002ff04344": {
    country_name: "Togo",
    country_name_ar: "توغو",
    region_code: "tg",
    country_code: "+228",
  },
  "5be9d423104d06002ff04355": {
    country_name: "United States",
    country_name_ar: "الولايات المتحدة الأمريكيّة",
    region_code: "us",
    country_code: "+1",
  },
  "5be9d423104d06002ff0435d": {
    country_name: "Vanuatu",
    country_name_ar: "فانواتو",
    region_code: "vu",
    country_code: "+678",
  },
  "5be9d423104d06002ff042b4": {
    country_name: "Fiji",
    country_name_ar: "فيجي",
    region_code: "fj",
    country_code: "+679",
  },
  "5be9d423104d06002ff042d8": {
    country_name: "Iceland",
    country_name_ar: "آيسلندا",
    region_code: "is",
    country_code: "+354",
  },
  "5be9d423104d06002ff042e2": {
    country_name: "Cambodia",
    country_name_ar: "كمبوديا",
    region_code: "kh",
    country_code: "+855",
  },
  "5be9d423104d06002ff042e4": {
    country_name: "Saint Kitts and Nevis",
    country_name_ar: "سانت كيتس ونيفيس",
    region_code: "kn",
    country_code: "+1-869",
  },
  "5be9d423104d06002ff042e8": {
    country_name: "Laos",
    country_name_ar: "جمهوريّة لاو الديمقراطية الشعبيّة",
    region_code: "la",
    country_code: "+856",
  },
  "5be9d423104d06002ff042eb": {
    country_name: "Libya",
    country_name_ar: "ليبيا",
    region_code: "ly",
    country_code: "+218",
  },
  "5be9d423104d06002ff0430a": {
    country_name: "Mayotte",
    country_name_ar: "مايوت",
    region_code: "yt",
    country_code: "+262",
  },
  "5be9d423104d06002ff0431f": {
    country_name: "Poland",
    country_name_ar: "بولندا",
    region_code: "pl",
    country_code: "+48",
  },
  "5be9d423104d06002ff04322": {
    country_name: "Portugal",
    country_name_ar: "البرتغال",
    region_code: "pt",
    country_code: "+351",
  },
  "5be9d423104d06002ff0432b": {
    country_name: "Saudi Arabia",
    country_name_ar: "المملكة العربيّة السعوديّة",
    region_code: "sa",
    country_code: "+966",
  },
  "5be9d423104d06002ff04341": {
    country_name: "Syria",
    country_name_ar: "سوريا",
    region_code: "sy",
    country_code: "+963",
  },
  "5be9d423104d06002ff04360": {
    country_name: "Yemen",
    country_name_ar: "اليمن",
    region_code: "ye",
    country_code: "+967",
  },
  "5be9d423104d06002ff042b0": {
    country_name: "Spain",
    country_name_ar: "إسبانيا",
    region_code: "es",
    country_code: "+34",
  },
  "5be9d423104d06002ff042c9": {
    country_name: "Guam",
    country_name_ar: "غوام",
    region_code: "gu",
    country_code: "+1-671",
  },
  "5be9d423104d06002ff042cf": {
    country_name: "Haiti",
    country_name_ar: "هايتي",
    region_code: "ht",
    country_code: "+509",
  },
  "5be9d423104d06002ff04324": {
    country_name: "Palestine",
    country_name_ar: "فلسطين",
    region_code: "ps",
    country_code: "+970",
  },
  "5be9d423104d06002ff04345": {
    country_name: "Thailand",
    country_name_ar: "تايلند",
    region_code: "th",
    country_code: "+66",
  },
  "5be9d423104d06002ff04351": {
    country_name: "Uganda",
    country_name_ar: "أوغندا",
    region_code: "ug",
    country_code: "+256",
  },
  "5be9d423104d06002ff04354": {
    country_name: "Uruguay",
    country_name_ar: "أوروغواي",
    region_code: "uy",
    country_code: "+598",
  },
  "5be9d423104d06002ff04356": {
    country_name: "Uzbekistan",
    country_name_ar: "أوزبكستان",
    region_code: "uz",
    country_code: "+998",
  },
  "5be9d423104d06002ff042b8": {
    country_name: "Micronesia",
    country_name_ar: "ميكرونيزيا",
    region_code: "fm",
    country_code: "+691",
  },
  "5be9d423104d06002ff042d0": {
    country_name: "Hungary",
    country_name_ar: "هنغاريا",
    region_code: "hu",
    country_code: "+36",
  },
  "5be9d423104d06002ff042fc": {
    country_name: "Macedonia",
    country_name_ar: "جمهوريّة مقدونيا اليوغوسلافية السابقة",
    region_code: "mk",
    country_code: "+389",
  },
  "5be9d423104d06002ff0430c": {
    country_name: "New Caledonia",
    country_name_ar: "كاليدونيا الجديدة",
    region_code: "nc",
    country_code: "+687",
  },
  "5be9d423104d06002ff04340": {
    country_name: "Seychelles",
    country_name_ar: "سيشيل",
    region_code: "sc",
    country_code: "+248",
  },
  "5be9d423104d06002ff04348": {
    country_name: "Turkmenistan",
    country_name_ar: "تركمانستان",
    region_code: "tm",
    country_code: "+993",
  },
  "5be9d423104d06002ff04350": {
    country_name: "Tanzania",
    country_name_ar: "جمهوريّة تنزانيا المتحدة",
    region_code: "tz",
    country_code: "+255",
  },
  "5be9d423104d06002ff042b2": {
    country_name: "Ethiopia",
    country_name_ar: "إثيوبيا",
    region_code: "et",
    country_code: "+251",
  },
  "5be9d423104d06002ff042b5": {
    country_name: "Falkland Islands",
    country_name_ar: "جزر فوكلاند",
    region_code: "fk",
    country_code: "+500",
  },
  "5be9d423104d06002ff042bc": {
    country_name: "Guernsey",
    country_name_ar: "غيرنسي",
    region_code: "gg",
    country_code: "+44-1481",
  },
  "5be9d423104d06002ff042c2": {
    country_name: "Guinea-Bissau",
    country_name_ar: "غينيا - بيساو",
    region_code: "gw",
    country_code: "+245",
  },
  "5be9d423104d06002ff042c7": {
    country_name: "Guatemala",
    country_name_ar: "غواتيمالا",
    region_code: "gt",
    country_code: "+502",
  },
  "5be9d423104d06002ff042e9": {
    country_name: "Lebanon",
    country_name_ar: "لبنان",
    region_code: "lb",
    country_code: "+961",
  },
  "5be9d423104d06002ff042ec": {
    country_name: "Saint Lucia",
    country_name_ar: "سانت لوسيا",
    region_code: "lc",
    country_code: "+1-758",
  },
  "5be9d423104d06002ff042f8": {
    country_name: "Madagascar",
    country_name_ar: "مدغشقر",
    region_code: "mg",
    country_code: "+261",
  },
  "5be9d423104d06002ff042fb": {
    country_name: "Marshall Islands",
    country_name_ar: "جزر مارشال",
    region_code: "mh",
    country_code: "+692",
  },
  "5be9d423104d06002ff042fd": {
    country_name: "Mali",
    country_name_ar: "مالي",
    region_code: "ml",
    country_code: "+223",
  },
  "5be9d423104d06002ff04315": {
    country_name: "Nauru",
    country_name_ar: "ناورو",
    region_code: "nr",
    country_code: "+674",
  },
  "5be9d423104d06002ff0431e": {
    country_name: "Papua New Guinea",
    country_name_ar: "بابوا غينيا الجديدة",
    region_code: "pg",
    country_code: "+675",
  },
  "5be9d423104d06002ff04321": {
    country_name: "North Korea",
    country_name_ar: "جمهوريّة كوريا الشعبيّة الديمقراطية",
    region_code: "kp",
    country_code: "+850",
  },
  "5be9d423104d06002ff04323": {
    country_name: "Paraguay",
    country_name_ar: "باراغواي",
    region_code: "py",
    country_code: "+595",
  },
  "5be9d423104d06002ff0432c": {
    country_name: "Sudan",
    country_name_ar: "السودان",
    region_code: "sd",
    country_code: "+249",
  },
  "5be9d423104d06002ff04343": {
    country_name: "Chad",
    country_name_ar: "تشاد",
    region_code: "td",
    country_code: "+235",
  },
  "5be9d423104d06002ff0434e": {
    country_name: "Tuvalu",
    country_name_ar: "توفالو",
    region_code: "tv",
    country_code: "+688",
  },
};

export default countries;



// WEBPACK FOOTER //
// ./src/core/countries.js